import { createReducer } from '../utils'

export const SET_DIALOG_ALERT_OPEN = 'sherrinford/dialogAlert/SET_DIALOG_ALERT_OPEN'

export const SET_ALERT_MESSAGE = 'sherrinford/dialogAlert/SET_ALERT_MESSAGE'

const initialStates = {
  isDialogAlertOpen: false,
  alertMessage: '',
}

export default createReducer(initialStates, {
  [SET_DIALOG_ALERT_OPEN]: (state, data) => ({
    ...state,
    isDialogAlertOpen: data,
  }),

  [SET_ALERT_MESSAGE]: (state, data) => ({
    ...state,
    alertMessage: data,
  }),
})

export const setDialogAlertOpen = data => ({
  type: [SET_DIALOG_ALERT_OPEN],
  payload: data,
})

export const setAlertMessage = data => ({
  type: [SET_ALERT_MESSAGE],
  payload: data,
})
